<template>
  <Button
    :class="sizeClass + (disabled ? '' : ' group')"
    :icon="
      textSizeClass +
      (disabled ? '' : ' group-hover:scale-120 group-hover:-rotate-5 duration-200 ease-out') +
      ' pi pi-' + props.icon
    "
    @click="emit('click')"
    :disabled
  ></Button>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  click: [];
}>();

interface Props {
  icon: string;
  small?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  small: false,
  disabled: false,
});

const textSizeClass = ref(props.small ? "text-base" : "text-xl");
const sizeClass = ref(props.small ? "h-8 w-8" : "h-10 w-10");
</script>
